import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { C, FONT } from '../theme';

export default function Layout({ children }) {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('kp_sidebar_collapsed') === '1');
  const toggle = () => setCollapsed(c => { const n = !c; localStorage.setItem('kp_sidebar_collapsed', n ? '1' : '0'); return n; });

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: C.pageBg, fontFamily: FONT, color: C.text }}>
      <Sidebar collapsed={collapsed} onToggle={toggle} />
      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
        <TopBar />
        <main style={{ flex: 1, minWidth: 0, background: C.pageBg }}>
          {children}
        </main>
      </div>
    </div>
  );
}
